import React from 'react';

export default function CheckIcon({ color }) {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0885 0L11.5 1.39077L4.79234 8L0.5 3.77064L1.91148 2.37988L4.79234 5.21847L10.0885 0Z"
        fill={color}
      />
    </svg>
  );
}
